import { DeedType } from 'generated/graphql';

export enum Privileges {
  // Restricted privileges (even super-admins need to have them in order to have access)
  RESTRICTED_INVOICING_VIEW = 'restricted:invoicing:view',
  RESTRICTED_INVOICING_MANAGE = 'restricted:invoicing:manage',

  DASHBOARD_VIEW = 'dashboard:view',
  ADVANCED_DASHBOARD_VIEW = 'advancedDashboard:view',

  USER_ACTIVITY_VIEW = 'userActivity:view',

  DEEDS_MANAGE = 'deeds:manage',
  BASE_EVENT_MANAGE = 'baseEvent:manage',
  EVENT_MANAGE = 'event:manage',
  PROJECT_MANAGE = 'project:manage',
  FUNDRAISER_MANAGE = 'fundraiser:manage',
  DEED_PUBLISH_LIVE = 'deed:publishLive',
  DEED_EDIT_PAST = 'deed:editPast',
  DEED_RATINGS_VIEW = 'deed:ratings:view',

  CAMPAIGN_MANAGE = 'campaign:manage',
  CAUSE_MANAGE = 'cause:manage',
  CHAPTERS_MANAGE = 'chapters:manage',
  CHALLENGES_VIEW = 'challenges:view',
  CHALLENGES_MANAGE = 'challenges:manage',
  COMMUNITIES_EDIT = 'communities:edit',
  COMMUNITIES_VIEW = 'communities:view',

  AUTO_SOURCE_MANAGE = 'autoSource:manage',

  DONATION_VIEW = 'donation:view',
  DONATION_MANAGE_RULES = 'donation:manageRules',
  DONATION_MATCH = 'donation:match',
  DONATION_MATCH_PAC_UPLOAD = 'donation:match:pacUpload',
  DONATION_CORPORATE_DONATE = 'donation:corporate:donate',
  DONATION_CORPORATE_LOG = 'donation:corporate:log',
  DONATION_INDIVIDUALS_VIEW = 'donation:individuals:view',
  DONATION_SCHEDULE_VIEW = 'donation:schedule:view',
  DONATION_SCHEDULE_MANAGE = 'donation:schedule:manage',

  DONATION_PAYROLL_VIEW = 'donation:payroll:view',
  DONATION_PAYROLL_EDIT = 'donation:payroll:edit',

  FORM_MANAGE = 'form:manage',

  SURVEY_MANAGE = 'survey:manage',

  ORGANIZATIONS_VIEW = 'organizations:view',
  ORGANIZATION_MANAGE_SETTINGS = 'organization:manageSettings',
  ORGANIZATION_MANAGE_USERS = 'organization:manageUsers',
  ORGANIZATION_VIEW_ORGANIZERS = 'organization:viewOrganizers',
  ORGANIZATION_MANAGE_ORGANIZERS = 'organization:manageOrganizers',
  ORGANIZATION_IMPERSONATE_USERS = 'organization:impersonateUsers',
  ORGANIZATION_SELF_VERIFY_OWNERSHIP = 'organization:selfVerifyOwnership',
  ORGANIZATION_SELF_VERIFIED = 'organization:selfVerified',
  ORGANIZATION_MANAGE_PAYMENTS = 'organization:managePayments',
  ORGANIZATION_SKIP_ONBOARDING = 'organization:skipOnboarding',
  // @NOTE-DP: Deed NPS team only!
  ORGANIZATION_VERIFY_ORGANIZER_USER_BY_DEED = 'organization:verifyOrganizerUserByDeed',

  NONPROFITS_UNBLOCK = 'nonprofits:unblock',

  PARTNER_MANAGE = 'partner:manage',

  ROLE_MANAGE = 'role:manage',

  VOLUNTEERS_MANAGE = 'volunteers:manage',

  VOLUNTEERTIME = 'volunteertime',

  VOLUNTEER_TIME_OFF_VIEW = 'volunteerTimeOff:view',

  REPORTS_VIEW = 'reports:view',
  REPORTS_VIEW_RESTRICTED = 'reports:viewRestricted',

  DEPARTMENTS_VIEW = 'departments:view',

  PICTURES_VIEW = 'pictures:view',

  PARTNER_VIEW = 'partner:view',

  ALL_LOCATIONS = 'allLocations:manage',

  EMPLOYEE_AFFILIATIONS_VIEW = 'employeeAffiliations:view',
  EMPLOYEE_AFFILIATIONS_MANAGE = 'employeeAffiliations:manage',

  BUDGET_LEDGER_VIEW = 'budgetLedger:view',
  BUDGET_LEDGER_MANAGE = 'budgetLedger:manage',

  DONATION_CREDIT_MANAGE = 'donation:credit:manage',

  NOTIFCATIONS_ORGANIZATION_MANAGE = 'notifications:organization:manage',
  PRODUCTBOARD_VIEW = 'productboard:view',

  ACTIONS_MANAGE = 'actions:manage',

  VOLUNTEER_REWARDS_MANAGE = 'volunteerReward:manage',

  GRANTS_MANAGE = 'grants:manage',

  ADDRESS_MANUAL_ENTRY = 'address:manualEntry',

  DEED_INTERNAL_HANDLE_NONPROFIT_NOMINATIONS = 'deedInternal:handleNonprofitNominations',

  IMPACT_AI_VIEW = 'impactAi:view',
}

export const DeedManagerPrivileges = {
  [DeedType.Campaign]: Privileges.FUNDRAISER_MANAGE,
  [DeedType.BaseEvent]: Privileges.BASE_EVENT_MANAGE,
  [DeedType.Event]: Privileges.EVENT_MANAGE,
  [DeedType.Project]: Privileges.PROJECT_MANAGE,
};

export const ImpactAiPrivileges = {
  // used as a guide about access to the Deed Form page  (organizer/app/containers/DeedFormPage/index.tsx)
  [DeedType.Campaign]: Privileges.FUNDRAISER_MANAGE, // Campaigns
  [DeedType.BaseEvent]: Privileges.BASE_EVENT_MANAGE, // Events
  [DeedType.Event]: Privileges.EVENT_MANAGE, // Volunteer Events
  [DeedType.Project]: Privileges.PROJECT_MANAGE, // Projects
};
